module.exports = __webpack_public_path__ + "img/138.d6f20b39.jpg";